import { Message } from 'element-ui'
// 配置背景
export const styleFuc = function (e) {
  let imgSearch = require('@/assets/drag/img/search-min.png')
  let imgText = require('@/assets/drag/img/text-min.png')
  let imgTextImg = require('@/assets/drag/img/nav-min.png')
  let imgBanner = require('@/assets/drag/img/banner-min.png')
  let imgImage = require('@/assets/drag/img/image-min.png')
  let imgGoods = require('@/assets/drag/img/goodsList-min.png')
  let imgGoodsTab = require('@/assets/drag/img/goodsTab-min.png')
  let imgCutUpLine = require('@/assets/drag/img/cutupLine-min.png')
  let imgMarketing = require('@/assets/drag/img/marketing-min.png')
  let ghostStyle = {
    background: '#f00',
    width: '375px',
    height: '0px',
  }
  switch (e) {
    case 1:
      ghostStyle.background = 'url(' + imgSearch + ')'
      ghostStyle.width = '375px'
      ghostStyle.height = '33px'
      break
    case 2:
      ghostStyle.background = 'url(' + imgText + ')'
      ghostStyle.width = '375px'
      ghostStyle.height = '48px'
      break
    case 3:
      ghostStyle.background = 'url(' + imgTextImg + ')'
      ghostStyle.width = '375px'
      ghostStyle.height = '146px'
      break
    case 4:
      ghostStyle.background = 'url(' + imgBanner + ')'
      ghostStyle.width = '375px'
      ghostStyle.height = '375px'
      break
    case 5:
      ghostStyle.background = 'url(' + imgImage + ')'
      ghostStyle.width = '375px'
      ghostStyle.height = '375px'
      break
    case 6:
      ghostStyle.background = 'url(' + imgGoods + ')'
      ghostStyle.width = '375px'
      ghostStyle.height = '329px'
      break
    case 7:
      ghostStyle.background = 'url(' + imgGoodsTab + ')'
      ghostStyle.width = '375px'
      ghostStyle.height = '364px'
      break
    case 8:
      ghostStyle.background = 'url(' + imgCutUpLine + ')'
      ghostStyle.width = '375px'
      ghostStyle.height = '10px'
      break
    case 9:
      ghostStyle.background = 'url(' + imgMarketing + ')'
      ghostStyle.width = '375px'
      ghostStyle.height = '124px'
      break
  }
  return ghostStyle
}

// 过滤 金额
// 回显金额
export const getAmount = (item, type) => {
  console.log(item.minCounterPrice)
  let Amount = item.minCounterPrice
  let Yuan = ''
  let Jiao = ''
  if (Amount && Amount.toString().indexOf('.') != -1) {
    Yuan += Amount.toString().split('.')[0]
    Jiao += Amount.toString().split('.')[1]
  } else {
    Yuan = Amount
  }
  if (type == 1) {
    if (Amount && Amount.toString().indexOf('.') != -1) {
      Yuan += '.'
    }
    return Yuan
  }
  if (type == 2) {
    return Jiao
  }
}

// 验证页面数据是否填写完成
export const verifyFuc = (pageInfo) => {
  let verify = true
  let typesTips = null
  let typesIndex = null
  if (pageInfo.pageSetting.pageName == '') {
    Message.warning('请输入页面标题')
    return 'home'
  }
  pageInfo.showArea.map((o, i) => {
    // 验证文本组件
    if (o.type == 2) {
      if (o.showIconType == 1) {
        if (o.linkType == '') {
          verify = false
          typesTips = '文本组件内容设置不完善'
          typesIndex = i
        }
      } else {
        if (o.titleTextarea == '') {
          verify = false
          typesTips = '文本组件内容设置不完善'
          typesIndex = i
        }
      }
    }
    // 图文导航验证
    if (verify && o.type == 3) {
      // console.log(o.itemImgList)
      o.itemImgList.map((oTextImg) => {
        if (oTextImg.title == '' || oTextImg.linkType == '') {
          verify = false
          typesTips = '图文导航组件内容设置不完善'
          typesIndex = i
        }
      })
    }
    // 轮播图验证
    if (verify && o.type == 4) {
      // console.log(o.itemImgList)
      o.itemImgList.map((oTextImg) => {
        if (oTextImg.title == '') {
          verify = false
          typesTips = '轮播图组件内容设置不完善'
          typesIndex = i
        }
      })
    }
    // 图片组件验证
    if (verify && o.type == 5) {
      // console.log(o.itemImgList)
      o.itemImgList.map((oTextImg) => {
        if (oTextImg.alignType == 1) {
          if (oTextImg.title == '') {
            verify = false
            typesTips = '图片组件内容设置不完善'
            typesIndex = i
          }
        } else {
          if (oTextImg.imgListHot.length == 0) {
            verify = false
            typesTips = '图片组件内容设置不完善'
            typesIndex = i
          } else {
            oTextImg.imgListHot.map((oHot) => {
              if (oHot.linkTitle == '' || oHot.linkType == '') {
                verify = false
                typesTips = '图片组件内容热区设置不完善'
                typesIndex = i
              }
            })
          }
        }
      })
    }
    // 商品验证
    if (verify && o.type == 6) {
      // console.log(o.itemImgList)
      if (o.goodsList.length == 0) {
        verify = false
        typesTips = '商品组件内容设置不完善'
        typesIndex = i
      }
    }
    // 商品分组验证
    if (verify && o.type == 7) {
      // console.log(o.itemImgList)
      o.itemImgList.map((oGoods) => {
        if (oGoods.title == '' || oGoods.goodsList.length == 0) {
          verify = false
          typesTips = '商品分组组件内容设置不完善'
          typesIndex = i
        }
      })
    }
    // 优惠劵验证
    if (verify && o.type == 9) {
      console.log(o.itemImgList)
      if (o.itemImgList.length == 0) {
        verify = false
        typesTips = '优惠券组件内容设置不完善'
        typesIndex = i
      }
    }

    // 商品分组验证
    if (verify && o.type == 10) {
      if (o.itemImgList.length == 0) {
        verify = false
        typesTips = '限时秒杀组件内容设置不完善'
        typesIndex = i
      } else {
        o.itemImgList.forEach((item) => {
          if (
            item.goodsNum == '' ||
            !item.goodsNum ||
            item.title == '' ||
            !item.title
          ) {
            verify = false
            typesTips = '限时秒杀组件内容设置不完善'
            typesIndex = i
          }
        })
      }
    }

    if (o.type == 11) {
      if (o.showNum == '') {
        verify = false
        typesTips = '首购专区组件请设置显示个数'
        typesIndex = i
      }

      if (o.background === null) {
        verify = false
        typesTips = '首购专区组件请选择背景颜色'
        typesIndex = i
      }
    }
    return verify
  })
  return {
    verify,
    typesTips,
    typesIndex,
  }
}

// 返回年月日
export const dataFormat = (date) => {
  let _date = new Date(date)
  let YY = _date.getFullYear()
  let MM = _date.getMonth() < 10 ? '0' + _date.getMonth() : _date.getMonth()
  let DD = _date.getDate() < 10 ? '0' + _date.getDate() : _date.getDate()
  let hh = _date.getHours() < 10 ? '0' + _date.getHours() : _date.getHours()
  let mm =
    _date.getMinutes() < 10 ? '0' + _date.getMinutes() : _date.getMinutes()
  let ss =
    _date.getSeconds() < 10 ? '0' + _date.getSeconds() : _date.getSeconds()
  return new Date(YY, MM, DD, hh, mm, ss)
}

export const dataFormatVal = (date) => {
  console.log(date, '88---8')
  let _date = new Date(date)
  let YY = _date.getFullYear()
  let MM =
    _date.getMonth() < 10 ? '0' + _date.getMonth() + 1 : _date.getMonth() + 1
  let DD = _date.getDate() < 10 ? '0' + _date.getDate() : _date.getDate()
  let hh = _date.getHours() < 10 ? '0' + _date.getHours() : _date.getHours()
  let mm =
    _date.getMinutes() < 10 ? '0' + _date.getMinutes() : _date.getMinutes()
  let ss =
    _date.getSeconds() < 10 ? '0' + _date.getSeconds() : _date.getSeconds()
  return YY + '-' + MM + '-' + DD + ' ' + hh + ':' + mm + ':' + ss
}

export const imgCutUp = (data) => {
  // console.log(data)
  if (data.indexOf(',') == -1) {
    // console.log(11111,data)
    return data
  }
  if (data.indexOf(',') != -1) {
    let arr = data.split(',')
    // console.log(2222,arr[0])
    return arr[0]
  }
}

export const dictData = (data) => {
  const obj = {
    品牌: '0101',
    单品单位: '0102',
    供应商类型: '0201',
    支付方式: '0202',
    销售职务: '0203',
    设备器材状态: '0204',
    员工人数: '0205',
    土地持有权: '0206',
    售后原因: '0301',
    订单取消原因: '0303',
    短信签名: '0401',
    补偿金类型: '0304',
  }
  return obj[data]
}

export const tagTypeName = (data) => {
  const obj = {
    height: '身高',
    weight: '体重',
    upBust: '上胸围',
    downBust: '下胸围',
    bust: '胸围',
    foot: '脚长',
    name: '',
  }
  return obj[data]
}

export const objectDelkey = (obj) => {
  let objCopy = JSON.parse(JSON.stringify(obj))
  let keysToDelete = ['pageNum', 'pageSize']
  keysToDelete.forEach((key) => {
    delete objCopy[key]
  })
  return objCopy
}

export const objectSavekey = (obj) => {
  let originalObject = JSON.parse(JSON.stringify(obj))
  let keysToKeep = ['pageNum', 'pageSize']
  const filteredObject = Object.fromEntries(
    Object.entries(originalObject).filter(([key]) => keysToKeep.includes(key))
  )
  return filteredObject
}
export const findMenuById = (tree, targetId, key) => {
  function traverse(node, path) {
    // 如果当前节点的 menuId 等于目标 ID，返回路径
    if (node[key] == targetId) {
      return path.concat(node[key])
    }

    // 如果有子节点，继续递归遍历
    if (node.children && node.children.length > 0) {
      for (let child of node.children) {
        const result = traverse(child, path.concat(node[key]))
        if (result) {
          return result
        }
      }
    }

    // 如果没有找到，返回 null
    return null
  }

  // 开始遍历
  for (let node of tree) {
    const result = traverse(node, [])
    if (result) {
      return result
    }
  }

  // 如果没有找到，返回空数组
  return []
}
